import { useEffect } from "react"
import { useNavigate, useParams } from "react-router"
import { useFieldArray, useForm } from "react-hook-form"

import { PayoutApi } from "services/api/PayoutApi"
import { useQuery } from "hooks/useQuery"
import { EditCalculatorType } from "models/payout"

import { TextField } from "components/TextField"
import { AppButton } from "components/AppButton"
import { AppLoader } from "components/AppLoader"
import { ROUTER_NAMES } from "router/routerNames"

import { calculatorResolver } from "../_helpers/calculator-resolver"
import styles from './EditPage.module.scss'

export const CalculatorPlanEdit = () => {
  const { plan_id } = useParams()
  const navigate = useNavigate()
  const { data, isFetched, fetching } = useQuery(() => PayoutApi.getCalcById(Number(plan_id)))

  const { register, control, setValue, handleSubmit, formState: { errors } } = useForm<EditCalculatorType>({
    resolver: calculatorResolver
  })

  const planValues = useFieldArray({
    control,
    name: 'plan.values'
  })

  const onSubmit = (values: EditCalculatorType) => {
    if (plan_id) {
      PayoutApi.editCalc(plan_id, values).then(() => {
        navigate(`${ROUTER_NAMES.CALCULATORS}`)
      })
    }
  }

  useEffect(() => {
    setValue('instant_payout', data.instant_payout)
    setValue('one_time_payout', data.one_time_payout)
    setValue('plan.name', data.plan?.name)
    setValue('plan.values', data.plan?.values)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetched, data])

  const removeValue = (idx: number) => {
    planValues.remove(idx)
  }

  const addValue = () => {
    planValues.append({
      id: 0,
      count: '',
      sum: '',
    })
  }

  if (fetching) return <AppLoader />

  return <div className="container">
    <form className={styles.form}>
      <div>

        <TextField
          {...register("one_time_payout")}
          inputSize="small"
          type="number"
          label="Платеж за готовую карту"
          required
          withError
          error={errors.one_time_payout}
        />

        <TextField
          {...register("instant_payout")}
          inputSize="small"
          type="number"
          label="Моментальный бонус"
          required
          withError
          error={errors.instant_payout}
        />

        <TextField
          {...register("plan.name", {
            required: "Заполните это поле",
          })}
          inputSize="small"
          label="Название плана"
          required
          withError
          error={errors.plan?.name}
        />
        <AppButton onClick={handleSubmit(onSubmit)}>
          Сохранить
        </AppButton>
        <AppButton
          onClick={() => navigate(ROUTER_NAMES.CALCULATORS)}
          variant="siren_border"
          style={{marginTop: 20}}
        >Назад</AppButton>
      </div>

      <div>
        <table>
          <thead>
            <tr>
              <th>Количество</th>
              <th>Бонус за план</th>
            </tr>
          </thead>
          <tbody>
            {planValues.fields.map((pVal, index) => {
              return (
                <tr>
                  <td>
                    <input type="number"
                      {...register(`plan.values.${index}.count`, {
                        required: "Заполните это поле",
                      })} />
                  </td>
                  <td>
                    <input type="number"
                      {...register(`plan.values.${index}.sum`, {
                        required: "Заполните это поле",
                      })} />
                  </td>
                  <td>
                    <AppButton variant="red" type="button" tabIndex={-1} onClick={() => removeValue(index)}>
                      Удалить
                    </AppButton>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>

        <AppButton variant="siren_border" type="button" onClick={addValue}>
          Добавить
        </AppButton>
      </div>
    </form>
  </div>
}